import React, { Component } from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import { connect } from 'react-redux';
import { compose } from 'redux';

import ScrollTop from './components/scrollToTop/ScrollToTop';
import PrivateRoute from './components/privateRoute';

import './style.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import Verify from './modules/verify/container';
import DetailECOM1 from './modules/detail/component/DetailECOM1';
import DetailECOM2 from './modules/detail/component/DetailECOM2';
import ShareDetail from './modules/detail/component/ShareDetail';

import Reward from './modules/reward/container';
import Cart from './modules/cart/container';
import Survey from './modules/survey/container';
import Pay from './modules/pay/container';
import Success from './modules/pay/component/Success';
import Failure from './modules/pay/component/Failure';
import routes from './routes';
import PageNotFound from '../shared/components/PageNotFound/PageNotFound';
import ThankYouPage from '../shared/components/Common/ThankYou';
import CancelSurveyPage from './modules/survey/component/cancelSurvey';
import QRCodePage from './modules/reward/component/QRCode';
import QRScannerPage from './modules/reward/component/QRCodeScanner';
import SuccessfulTransaction from './modules/reward/component/TransactionSucessful';
import Address from './modules/detail/component/AddressForm';

class App extends Component {
    constructor(props: Record<string, unknown>) {
        super(props);
        this.state = {};
    }

    componentDidMount() {
        if ((this.props as { isAuthenticated?: boolean }).isAuthenticated) {
            // reserved for post-auth side effects
        }
    }

    render() {
        return (
            <React.Fragment>
                <ScrollTop>
                    <Routes>
                        <Route path={routes.home} element={<Navigate to={routes.verify} replace />} />
                        <Route path={routes.verify} element={<Verify />} />
                        <Route path={routes.detailecom1} element={<DetailECOM1 />} />
                        <Route path={routes.detailecom2} element={<DetailECOM2 />} />
                        <Route path={routes.sharedetail} element={<ShareDetail />} />
                        <Route
                            path={routes.reward}
                            element={
                                <PrivateRoute>
                                    <Reward />
                                </PrivateRoute>
                            }
                        />
                        <Route
                            path={routes.cart}
                            element={
                                <PrivateRoute>
                                    <Cart />
                                </PrivateRoute>
                            }
                        />
                        <Route path={routes.survey} element={<Survey />} />
                        <Route
                            path={routes.pay}
                            element={
                                <PrivateRoute>
                                    <Pay />
                                </PrivateRoute>
                            }
                        />
                        <Route path={routes.success} element={<Success />} />
                        <Route path={routes.successTransaction} element={<SuccessfulTransaction />} />
                        <Route path={routes.failure} element={<Failure />} />
                        <Route path={routes.thankYou} element={<ThankYouPage />} />
                        <Route path={routes.qrCode} element={<QRCodePage />} />
                        <Route path={routes.qrCodeScanner} element={<QRScannerPage />} />
                        <Route path={routes.cancelSurvey} element={<CancelSurveyPage />} />
                        <Route path={routes.address} element={<Address />} />
                        <Route path="*" element={<PageNotFound />} />
                    </Routes>
                </ScrollTop>
            </React.Fragment>
        );
    }
}

function select(store: { verify: { isAuthenticated: boolean } }) {
    return {
        isAuthenticated: store.verify.isAuthenticated,
    };
}

export default compose(connect(select))(App);
